import { Params } from 'types/global';

import { hasArrayValues } from 'utils/array/arrays';

export const getCatchAllSlug = (params: Params['params']) =>
  hasArrayValues(params?.slug) ? `/${params.slug.join('/')}` : '/';

export const getDynamicSlug = (params: Params['params'], pathRoot?: string) => {
  const slug = params?.slug;

  return `/${pathRoot || ''}/${slug}`;
};

export const forceHttps = (url?: string): string | undefined => {
  if (!url || url.startsWith('/')) {
    return url;
  }

  if (url.startsWith('http://')) {
    return url.replace('http://', 'https://');
  }

  return url;
};

export const addTrailingSlash = (url?: string): string | undefined => {
  if (!url) {
    return url;
  }

  const trimmedUrl = url.trim();
  if (!trimmedUrl) {
    return url;
  }

  try {
    const urlObj = new URL(trimmedUrl.includes('://') ? trimmedUrl : `https://${trimmedUrl}`);
    if (!urlObj.pathname.endsWith('/')) {
      urlObj.pathname += '/';
    }

    return urlObj.toString();
  } catch {
    const [path, ...rest] = trimmedUrl.split(/[?#]/);

    return path.endsWith('/') ? trimmedUrl : `${path}/${rest.length ? `?${rest.join('?')}` : ''}`;
  }
};

export const getSafePath = () => {
  const p = typeof window !== 'undefined' ? window.location.pathname : '/';

  return p && p.trim().length ? p : '/';
};
